import { useNavigation } from '@react-navigation/native';
import { PixelRatio, View } from 'react-native';
import React from 'react';
import { useI18n } from '../../context/I18nContext';
import GradientButton from '../../components/GradientButton';
import { screenNames } from '../../navigators/screenNames';
import { AppDrawerNavigationProp } from '../../components/DrawerMenuContent';
import { CompoundReservation } from '../../types/misc.types';
import { useNowMinutes } from '../../hooks/useNow';
import { useMapViewFilter } from '../../context/MapViewFilterContext';
import Spacer from '../../components/Spacer';
import Typography from '../../components/Typography';
import { styles } from './sharedCardConfig';
import { Maybe, ProductSubscription } from '../../types/appsync-types';

const ReservationContent = ({ reservation }: { reservation: CompoundReservation | undefined }) => {
  const { I18n, formatDate } = useI18n();
  const navigation = useNavigation<AppDrawerNavigationProp>();
  const now = useNowMinutes();
  const { timeZone } = useMapViewFilter();
  const hasLargeFont = PixelRatio.getFontScale() > 2;
  // const caption = I18n.t('mapview.podInfoCard.bookedNotNowTitle');
  // const dateStr = capitalizeFirstLetter(
  //   formatRelative(new Date(reservation?.from ?? now), now, reservation?.timeZone, CARD_DATE_FMT_OPTS),
  // );
  // const startEnd = reservation ? formatDateRange(reservation.from, reservation.to, 'time', reservation.timeZone) : '';
  return (
    <>
      {/* <BookingCardDurationSelector
        pickerText={formatDuration(filter.durationInSecond, 'seconds')}
        pickerMin={minBookingMins}
        pickerMax={maxBookingMins}
        pickerValue={filter.durationInSecond / 60}
        pickerStep={60}
        onValueChange={(newValue) =>
          onChange({
            ...filter,
            durationInSecond: newValue * 60,
          })
        }
        caption={caption}
        details={`${dateStr}\n${startEnd}`}
      /> */}
      <View style={[styles.scheduleSection, { flexDirection: hasLargeFont ? 'column' : 'row' }]}>
        <Typography variant={'body1'}>
          {I18n.t('mapview.podInfoCard.bookedNotNowTitle', {
            time: formatDate(new Date(reservation?.from ?? now), 'time', reservation?.timeZone ?? timeZone),
          })}
        </Typography>
      </View>
      <Spacer />

      {reservation?.initialId && (
        <GradientButton
          onPress={() => {
            navigation.navigate('map', {
              screen: screenNames.BookingDetail,
              params: reservation?.initialId
                ? {
                    bookingId: reservation.initialId,
                  }
                : undefined,
            });
          }}
        >
          {I18n.t('mapview.podInfoCard.viewBooking')}
        </GradientButton>
      )}
    </>
  );
};

const ProductReservationContent = ({
  productReservation,
  buildingTimezone,
}: {
  productReservation: ProductSubscription;
  buildingTimezone: string | undefined | null;
}) => {
  const { I18n, formatDate } = useI18n();
  const navigation = useNavigation<AppDrawerNavigationProp>();
  const now = useNowMinutes();
  const { timeZone } = useMapViewFilter();
  const hasLargeFont = PixelRatio.getFontScale() > 2;

  return (
    <>
      <View style={[styles.scheduleSection, { flexDirection: hasLargeFont ? 'column' : 'row' }]}>
        <Typography variant={'body1'}>
          {I18n.t('mapview.podInfoCard.bookedNotNowTitle', {
            time: formatDate(new Date(productReservation.startDate ?? now), 'time', buildingTimezone ?? timeZone),
          })}
        </Typography>
      </View>
      <Spacer />

      {!!productReservation.productId && (
        <GradientButton
          onPress={() => {
            navigation.navigate('map', {
              screen: screenNames.ReservationProductDetailScreen,
              params: {
                productId: productReservation.productId,
              },
            });
          }}
        >
          {I18n.t('mapview.podInfoCard.viewBooking')}
        </GradientButton>
      )}
    </>
  );
};

type Props = {
  reservation: CompoundReservation | undefined;
  productReservation: Maybe<ProductSubscription> | undefined;
  buildingTimezone: string | undefined | null;
  minBookingMins: number | undefined;
  maxBookingMins: number | undefined;
};

export const BookedNotNowCardContent = ({
  reservation,
  productReservation,
  buildingTimezone,
  minBookingMins,
  maxBookingMins,
}: Props) => {
  if (productReservation) {
    return <ProductReservationContent productReservation={productReservation} buildingTimezone={buildingTimezone} />;
  }
  return <ReservationContent reservation={reservation} />;
};
